module.exports = __webpack_public_path__ + "img/sun.df0aca15.svg";